import { literal, object, pipe } from 'valibot';

import { EmailSchema } from './EmailSchema';
import { PasswordSchema } from './PasswordSchema';
import { fieldIsRequiredTranslationKey, stringRequired } from './schema.utils';

export const RegistrationSchema = () =>
  pipe(
    object({
      firstName: stringRequired(),
      lastName: stringRequired(),
      email: EmailSchema(),
      password: PasswordSchema(),
      confirmPassword: PasswordSchema(),
      acceptTermsAndPrivacyPolicy: literal(true, fieldIsRequiredTranslationKey)
    })
  );
